<section class="background-nearwhite">
    <div class="container" *ngIf="countriesData$ | async as countriesData">
        <h1
            *ngIf="
                !isDataProtection &&
                !isGeneralTerms &&
                !isLegalNotice &&
                !isSupplierIndentification &&
                !isTransparency &&
                !isLicenses &&
                !isNotice &&
                !isTermsAndConditionsOfSale
            "
        >
            Select a country/region and language
        </h1>
        <h1 *ngIf="isDataProtection">Select your country to display the data protection guidelines</h1>
        <h1 *ngIf="isGeneralTerms">Select your country to display terms and conditions</h1>
        <h1 *ngIf="isLegalNotice">Select your country to display the legal notice</h1>
        <h1 *ngIf="isSupplierIndentification">Select your country to display the supplier identification</h1>
        <h1 *ngIf="isTransparency">Select your country to display the transparency</h1>
        <h1 *ngIf="isLicenses">Select your country to display the licenses</h1>
        <h1 *ngIf="isTermsAndConditionsOfSale">Select your country to display the terms and conditions of sale</h1>
        <h1 *ngIf="isNotice">Select your country</h1>
        <div class="row flex-lg-nowrap">
            <ng-container *ngFor="let countryLinkListGroup of countriesData">
                <div class="col col-lg-auto">
                    <ng-container *ngFor="let countryLinkList of countryLinkListGroup.items">
                        <div class="region" *ngIf="countryLinkListGroup.items.length > 0">
                            <h3>
                                {{ countryLinkList.Headline }}
                            </h3>
                            <ul class="reset">
                                <ng-container *ngFor="let linkList of countryLinkList.linkList">
                                    <li
                                        *ngIf="
                                            !isGeneralTerms &&
                                            !isDataProtection &&
                                            !isLegalNotice &&
                                            !isTransparency &&
                                            !isLicenses &&
                                            !isSupplierIndentification &&
                                            !isNotice &&
                                            linkList.showOnSelection &&
                                            !isTermsAndConditionsOfSale
                                        "
                                    >
                                        <a
                                            class="link-list"
                                            da-link
                                            href="{{ '/' + linkList.homeUrl }}"
                                            (click)="setCountryCookie(linkList.site)"
                                        >
                                            <img
                                                class="flag"
                                                [src]="getCountryFlag(linkList.site) | globalAsset"
                                                alt="{{ linkList.label }}"
                                            />
                                            <span>{{ linkList.label }}</span>
                                        </a>
                                    </li>

                                    <li *ngIf="isDataProtection && linkList.protectionLabel">
                                        <a
                                            class="link-list"
                                            da-link
                                            href="{{ '/' + linkList.protectionUrl }}"
                                            (click)="setCountryCookie(linkList.site)"
                                        >
                                            <img
                                                class="flag"
                                                [src]="getCountryFlag(linkList.site) | globalAsset"
                                                alt="{{ linkList.protectionLabel }}"
                                            />
                                            <span>{{ linkList.protectionLabel }}</span>
                                        </a>
                                    </li>

                                    <li *ngIf="isGeneralTerms && linkList.termsLabel">
                                        <a
                                            class="link-list"
                                            da-link
                                            href="{{ '/' + linkList.termsUrl }}"
                                            (click)="setCountryCookie(linkList.site)"
                                        >
                                            <img
                                                class="flag"
                                                [src]="getCountryFlag(linkList.site) | globalAsset"
                                                alt="{{ linkList.termsLabel }}"
                                            />
                                            <span>{{ linkList.termsLabel }}</span>
                                        </a>
                                    </li>

                                    <li *ngIf="isLegalNotice && linkList.legalNoticeLabel">
                                        <a
                                            class="link-list"
                                            da-link
                                            href="{{ '/' + linkList.legalNoticeUrl }}"
                                            (click)="setCountryCookie(linkList.site)"
                                        >
                                            <img
                                                class="flag"
                                                [src]="getCountryFlag(linkList.site) | globalAsset"
                                                alt="{{ linkList.legalNoticeLabel }}"
                                            />
                                            <span>{{ linkList.legalNoticeLabel }}</span>
                                        </a>
                                    </li>

                                    <li *ngIf="isNotice && linkList.noticeLabel">
                                        <a
                                            class="link-list"
                                            da-link
                                            href="{{ '/' + linkList.noticeUrl }}"
                                            (click)="setCountryCookie(linkList.site)"
                                        >
                                            <img
                                                class="flag"
                                                [src]="getCountryFlag(linkList.site) | globalAsset"
                                                alt="{{ linkList.noticeLabel }}"
                                            />
                                            <span>{{ linkList.noticeLabel }}</span>
                                        </a>
                                    </li>

                                    <li *ngIf="isSupplierIndentification && linkList.supplierIndentificationLabel">
                                        <a
                                            class="link-list"
                                            da-link
                                            href="{{ '/' + linkList.supplierIndentificationUrl }}"
                                            (click)="setCountryCookie(linkList.site)"
                                        >
                                            <img
                                                class="flag"
                                                [src]="getCountryFlag(linkList.site) | globalAsset"
                                                alt="{{ linkList.supplierIndentificationLabel }}"
                                            />
                                            <span>{{ linkList.supplierIndentificationLabel }}</span>
                                        </a>
                                    </li>

                                    <li *ngIf="isTransparency && linkList.transparencyLabel">
                                        <a
                                            class="link-list"
                                            da-link
                                            href="{{ '/' + linkList.transparencyeUrl }}"
                                            (click)="setCountryCookie(linkList.site)"
                                        >
                                            <img
                                                class="flag"
                                                [src]="getCountryFlag(linkList.site) | globalAsset"
                                                alt="{{ linkList.transparencyLabel }}"
                                            />
                                            <span>{{ linkList.transparencyLabel }}</span>
                                        </a>
                                    </li>

                                    <li *ngIf="isLicenses && linkList.licensesLabel">
                                        <a
                                            class="link-list"
                                            da-link
                                            href="{{ '/' + linkList.licensesUrl }}"
                                            (click)="setCountryCookie(linkList.site)"
                                        >
                                            <img
                                                class="flag"
                                                [src]="getCountryFlag(linkList.site) | globalAsset"
                                                alt="{{ linkList.licensesLabel }}"
                                            />
                                            <span>{{ linkList.licensesLabel }}</span>
                                        </a>
                                    </li>

                                    <li *ngIf="isTermsAndConditionsOfSale && linkList.termsAndConditionsOfSaleLabel">
                                        <a
                                            class="link-list"
                                            da-link
                                            href="{{ '/' + linkList.termsAndConditionsOfSaleUrl }}"
                                            (click)="setCountryCookie(linkList.site)"
                                        >
                                            <img
                                                class="flag"
                                                [src]="getCountryFlag(linkList.site) | globalAsset"
                                                alt="{{ linkList.termsAndConditionsOfSaleLabel }}"
                                            />
                                            <span>{{ linkList.termsAndConditionsOfSaleLabel }}</span>
                                        </a>
                                    </li>
                                </ng-container>
                            </ul>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</section>
